import React from 'react';
import RestrictionsSection from '../../../sections/AdminDashboard/SecurityFraud/Restrictions';

const Restrictions = () => {
  return <RestrictionsSection />;
};

export default Restrictions;

